import {Directive, Inject, TemplateRef} from "@angular/core";

/**
 * Template markers for app-bringoz-data-table custom header / row markup.
 *
 * Both are plain TemplateRef holders, kept in one file because they only make sense as a pair.
 * The table renders them with ngTemplateOutlet rather than <ng-content select="...">, because
 * the projected .th / .td cells have to end up as direct flex children of the .tr row - any
 * wrapper element in between breaks the column layout.
 */

@Directive({
  standalone: false,
  selector: 'ng-template[tableHeader]'
})
export class TableHeaderDefDirective {
  constructor(@Inject(TemplateRef) public templateRef: TemplateRef<any>) {
  }
}

@Directive({
  standalone: false,
  selector: 'ng-template[tableRow]'
})
export class TableRowDefDirective {
  constructor(@Inject(TemplateRef) public templateRef: TemplateRef<{ $implicit: any, index: number }>) {
  }
}
